<script lang="ts">
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Design system components
	import { Button, Checkbox, Select } from '@Shelly/shelly-design-system';
	//Helpers
	import { real_id, real_id_z } from 'src/helpers/interface_helpers';
	//Services
	import { postReq } from 'src/services/http';
	import { format } from 'svelte-i18n';
	//Stores
	import {
		getDeviceStatus,
		getDeviceSettings,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';
	//Types
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { ZWAVE_DEVICE_API } from 'src/helpers/z_wave_qr_helpers';

	export let device;

	let loading = false;

	const frequencies = [
		'Europe',
		'USA',
		'Australia/New Zealand',
		// 'Hong Kong',
		// 'India',
		// 'Israel',
		// 'Russia',
		// 'China',
		// 'USA (Long Range)',
		// 'Japan',
		// 'Korea'
	];

	//this is a z wave setting. the only reason to be here is that we treated the gateway as gen2/3 device

	//TODO: this setting is work in progress. Needed proper settings received from cloud

	const frequencyLabels = {
		Europe: $format('option_europe', { default: 'Europe' }),
		USA: $format('option_united_states', {
			default: 'USA',
		}),
		'Australia/New Zealand': $format('option_australia_new_zealand', {
			default: 'Australia/New Zealand',
		}),
		// HongKong: $format('label_hong_kong', { default: 'Hong Kong' }),
		// India: $format('label_india', { default: 'India' }),
		// Israel: $format('label_israel', { default: 'Israel' }),
		// Russia: $format('label_russia', { default: 'Russia' }),
		// China: $format('label_china', { default: 'China' }),
		// 'USA (Long Range)': $format('label_united_states_long_range', {
		// 	default: 'United States Long Range'
		// }),
		// Japan: $format('label_japan', { default: 'Japan' }),
		// Korea: $format('label_korea', { default: 'Korea' })
	};

	$: settingsStore = getDeviceSettings(device.id);
	let settings = readDeviceSettings(device.id);
	$: settings = $settingsStore ?? settings;

	let frequency = settings?.rf_region || frequencies[0];

	// enum RFRegion {
	// 	'Europe' = 0x00,
	// 	'USA' = 0x01,
	// 	'Australia/New Zealand' = 0x02,
	// 	'Hong Kong' = 0x03,
	// 	'India' = 0x05,
	// 	'Israel' = 0x06,
	// 	'Russia' = 0x07,
	// 	'China' = 0x08,
	// 	'USA (Long Range)' = 0x09,
	// 	'Japan' = 0x20,
	// 	'Korea' = 0x21,
	// 	'Unknown' = 0xfe,
	// 	'Default (EU)' = 0xff
	// }
	const setFrequency = async (e) => {
		frequency = frequencies[Object.values(frequencyLabels).indexOf(e.detail)];
	};
	const changeFrequency = async () => {
		loading = true;
		frequencies.map((f) => {
			if (f != frequency) settings[f] = false;
		});
		const params = {
			id: real_id_z(device.id), //gateway's id
			a: 'rfset', //inclusion command
			rgn: frequency,
		};
		const res: SettingRequest = await postReq(ZWAVE_DEVICE_API, {
			...params,
		});
		if (res.isok) {
			settings[frequency] = true;
			devices_settings.update_devices_settings(device.id, settings);
		}
		onSettingsResponse(res, device);
		loading = false;
	};

	console.warn(settings);
</script>

<Select
	class="mb-s"
	value={frequencyLabels[frequency]}
	options={Object.values(frequencyLabels)}
	icon={null}
	on:change={setFrequency}
	id="select-uj3b978"
	aria-label={$format('select_frequency', { default: 'Select frequency' })}
/>
<Button {loading} class="mt-s" size="m" width="full" on:click={changeFrequency}
	>{$format('button_save')}</Button
>
<!-- {#each frequencies as freq}
	{freq}
	<Checkbox
		class="mb-s"
		size="m"
		bind:checked={settings[freq]}
		on:click={() => changeFrequency(freq)}>{frequencyLabels[freq]}</Checkbox
	>
{/each} -->
